/** @graphql cc **/

import gql from 'graphql-tag';

export const CcpEntitlementQuery = gql`
	query CcpEntitlementQuery {
		confluence_tenantContext {
			licenseStates {
				confluence {
					ccpEntitlementId
				}
			}
		}
		tenant {
			cloudId
		}
	}
`;
